import { EstimatedShipping } from '@app/types/monolith/cart';
import { CartQueryShippingAddress } from '@app/types/monolith/types';

export const isExpressShipping = (
  estimatedShipping: Pick<EstimatedShipping, 'allow_express' | 'preference'>
): boolean =>
  estimatedShipping.allow_express && estimatedShipping.preference === 'express';

export const getEstimatedShippingValue = (
  estimatedShipping: Pick<
    EstimatedShipping,
    | 'allow_express'
    | 'preference'
    | 'express'
    | 'express_ex_tax'
    | 'standard'
    | 'standard_ex_tax'
  >,
  showTaxSeparately: boolean
): number => {
  if (isExpressShipping(estimatedShipping)) {
    return showTaxSeparately
      ? estimatedShipping.express_ex_tax
      : estimatedShipping.express;
  }
  return showTaxSeparately
    ? estimatedShipping.standard_ex_tax
    : estimatedShipping.standard;
};

export const shippingAddressToCartParams = (
  address?: CartQueryShippingAddress | null
) => {
  if (!address) return null;

  const { countryCode, postcode, state } = address;

  return {
    ...(countryCode && { country_code: countryCode.toUpperCase() }),
    ...(postcode && { postcode }),
    ...(state && { state: state.toUpperCase() }),
  };
};
